import { Injectable } from '@angular/core';
import {
  Route,
  RouteFragment,
  RouteParam,
  RouteProviderService,
  RouterLinkWithParts,
} from '@web/common';

@Injectable()
export class AppRoutesProviderService extends RouteProviderService {
  public override routes(): Map<Route, RouterLinkWithParts> {
    /* prettier-ignore */
    return new Map<Route, RouterLinkWithParts>([
      [Route.Loading, [RouteFragment.Root, RouteFragment.Loading]],
      [Route.NotFound, [RouteFragment.Root, RouteFragment.NotFound]],
      [Route.PL_Account, [RouteFragment.Root, RouteFragment.PL_Account]],
      [Route.PL_AccountAddresses, [RouteFragment.Root, RouteFragment.PL_Account, RouteFragment.PL_Addresses]],
      [Route.PL_AccountDetails, [RouteFragment.Root, RouteFragment.PL_Account, RouteFragment.PL_Details]],
      [Route.PL_AccountOrderDetails, [RouteFragment.Root, RouteFragment.PL_Account, RouteFragment.PL_Orders, RouteParam.Number]],
      [Route.PL_AccountOrders, [RouteFragment.Root, RouteFragment.PL_Account, RouteFragment.PL_Orders]],
      [Route.PL_AccountQuestionnaireDetails, [RouteFragment.Root, RouteFragment.PL_Account, RouteFragment.PL_Questionnaires, RouteParam.Guid]],
      [Route.PL_AccountQuestionnaires, [RouteFragment.Root, RouteFragment.PL_Account, RouteFragment.PL_Questionnaires]],
      [Route.PL_AccountSubscriptionDetails, [RouteFragment.Root, RouteFragment.PL_Account, RouteFragment.PL_Subscriptions, RouteParam.Number]],
      [Route.PL_AccountSubscriptions, [RouteFragment.Root, RouteFragment.PL_Account, RouteFragment.PL_Subscriptions]],
      [Route.PL_AccountBeautyProfile, [RouteFragment.Root, RouteFragment.PL_Account, RouteFragment.PL_BeautyProfile]],
      [Route.PL_BoxDetails, [RouteFragment.Root, RouteFragment.PL_Boxes, RouteParam.Slug]],
      [Route.PL_BoxDetailsAuthorization, [RouteFragment.Root, RouteFragment.PL_Boxes, RouteParam.Slug, RouteFragment.PL_Authorization]],
      [Route.PL_Boxes, [RouteFragment.Root, RouteFragment.PL_Boxes]],
      [Route.PL_BrandDetails, [RouteFragment.Root, RouteFragment.PL_Brands, RouteParam.Slug]],
      [Route.PL_Brands, [RouteFragment.Root, RouteFragment.PL_Brands]],
      [Route.PL_Checkout, [RouteFragment.Root, RouteFragment.PL_Checkout]],
      [Route.PL_Contact, [RouteFragment.Root, RouteFragment.PL_Contact]],
      [Route.PL_CosmeticDetails, [RouteFragment.Root, RouteFragment.PL_Cosmetics, RouteParam.Slug]],
      [Route.PL_FAQ, [RouteFragment.Root, RouteFragment.PL_FAQ]],
      [Route.PL_OrderBox, [RouteFragment.Root, RouteFragment.PL_OrderBox]],
      [Route.PL_OrderPaymentRedirection, [RouteFragment.Root, RouteFragment.PL_Order, RouteParam.Guid, RouteFragment.PL_Redirection, RouteParam.Token]],
      [Route.PL_OrderSummaryWithToken, [RouteFragment.Root, RouteFragment.PL_Order, RouteParam.Guid, RouteFragment.PL_Summary, RouteParam.Token]],
      [Route.PL_Payment, [RouteFragment.Root, RouteFragment.PL_Payment]],
      [Route.PL_PrivacyPolicy, [RouteFragment.Root, RouteFragment.PL_PrivacyPolicy]],
      [Route.PL_Products, [RouteFragment.Root, RouteFragment.PL_Products]],
      [Route.PL_ProductDetails, [RouteFragment.Root, RouteFragment.PL_Products, RouteParam.Slug]],
      [Route.PL_ProductDetailsAuthorization, [RouteFragment.Root, RouteFragment.PL_Products, RouteParam.Slug, RouteFragment.PL_Authorization]],
      [Route.PL_RegulationsOfPublishingOpinions, [RouteFragment.Root, RouteFragment.PL_Regulations, RouteFragment.PL_PublishingOpinions]],
      [Route.PL_RegulationsOfShop, [RouteFragment.Root, RouteFragment.PL_Regulations, RouteFragment.PL_Shop]],
      [Route.PL_ShoppingCartDetails, [RouteFragment.Root, RouteFragment.PL_ShoppingCart]],
      [Route.Redirection, [RouteFragment.Root, RouteFragment.Redirect]],
      [Route.Root, [RouteFragment.Root]],
      [Route.SignIn, [RouteFragment.Root, RouteFragment.SignIn]],
      [Route.SignOut, [RouteFragment.Root, RouteFragment.SignOut]],
      [Route.SignUp, [RouteFragment.Root, RouteFragment.SignUp]],
    ]);
  }
}
